







































import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ContextsState } from '@/store';
import DataSource from 'devextreme/data/data_source';
import {
    Table,
    TableOptions,
    removeItemsFromView,
    getTableCaption,
} from '@/core/components/table';
import { Page } from '@/core/components/controls';
import { DxDataGrid } from 'devextreme-vue/data-grid';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract,
    EventsServiceContract,
    Events
} from '@/core/contracts';
import { lookupField, guid } from '@/core/helpers';
import { Site, Sites } from '@/dto';
import { IContext } from '@/api/dto';
import SitesListTable from './SitesListTable.vue';
import DevExpress from 'devextreme/bundles/dx.all';

@Component({
    components: {
        DxDataGrid,
        SitesListTable,
        TableOptions,
    },
})
export default class SitesListPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'sitesList-control';

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'id' as keyof Site,
            load: this.load,
            insert: (site: Site) => this.insert(site),
            update: (id: string, data: Site) => this.update(id, data),
        });
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get isRowSelected() {
        return this.table && this.table!.getSelectedRowKeys().length === 1;
    }

    public addSite() {
        this.table!.addRow();
    }

    public editSite() {
        const selectedKey = this.table!.getSelectedRowKeys()[0];

        if (selectedKey) {
            const selectedIndex = this.table!.getRowIndexByKey(selectedKey);
            this.table!.editRow(selectedIndex);
        }
    }

    public get selectedRow() {
        if (this.table && this.table!.getSelectedRowKeys().length === 1) {
            return this.table!.getSelectedRowsData()[0];
        }
    }

    private showInactivityIntervals() {
        this._windowsService!.open('inactivity-intervals-list-page', {
            alias: (this.selectedRow as Site).id
        });
    }

    private get siteIsVisible() {
        return this.selectedRow ? (this.selectedRow as Site).isVisible : false;
    }

    private deleteSite() {
        const table = this.$refs['table-component'] as SitesListTable;
        table.deleteSite();
    }

    private async load() {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}/Sites`;
        const data = await this._fetchService!.get<IContext>(url);
        return data.sites ? data.sites : [];
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async insert(site: Site) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        site.id = guid();
        const data = {
            Sites_Partial: [site],
        };
        return await this._fetchService!.post<Site>(url, JSON.stringify(data));
    }

    private async update(id: string, site: Site) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        site.id = id;
        const data = {
            Sites_Partial: [site],
        };
        return await this._fetchService!.post<Site>(url, JSON.stringify(data));
    }
}
